<template>
    <div>
        <el-dialog
         title="商品属性标签"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="500px"
        :before-close="handleClose"
         >
            <el-form :model="filters" class="toolbar formStyle bordernone" ref="filters" label-width="80px" style="padding-bottom:0">
                <el-row style="padding-bottom: 0px;">
                    <el-col :span="24">
                        <el-form-item label="商品条码" prop="barcode">
                            <el-input v-model="filters.barcode" placeholder="请输入商品名称" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="padding-bottom: 0px;">
                    <el-col :span="24">
                        <el-form-item label="小类" prop="subclass">
                            <el-input v-model="filters.subclass" placeholder="请输入商品名称" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-form class="toolbar formStyle foreachForm" :model="form" ref="form" label-width="80px" :hide-required-asterisk="true">
                <el-row style="padding-bottom: 0px;">
                    <el-col :span="24" style="position:relative" v-for="(item,i) in form.formList" :key="i">
                        <span class="star" v-if="isValidate(item)">*</span>
                        <el-form-item :label="item.lbName" :prop="'formList.'+i+'.lbValue'" :rules="isValidate(item) ? [{ required: true, message: '　', trigger: ['blur', 'change']}] : [{ required: false}]" v-if="item">
                            <el-select v-model="item.lbValue" v-if="item.valueList && item.valueList.length > 0" clearable :disabled="check == true">
                                <el-option
                                    v-for="val in item.valueList"
                                    :key="val.ldName"
                                    :label="val.ldName"
                                    :value="val.ldName"
                                    >
                                </el-option>
                            </el-select>
                            <el-input v-model="item.lbValue" placeholder="" v-else></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click.native="submit('form')" v-if="form.formList && form.formList.length >= 1" :loading="saveLoading" :disabled="check == true">保存</el-button>
                <el-button @click.native="handleClose()">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
//分页组件
import Pagination from '@/components/Pagination';
export default {
    data(){
        return{
            filters:{
                barcode:'',
                subclass:'',
            },
            form:{
                formList:[
                    {lbValue:''}
                ],
            },
            saveLoading:false,
        }
    },
    components: {
        Pagination,
    },
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        itemappId:{
            type:Number,
            required:true,
        },
        item:{
            type:String,
            required:true,
        },
        check:{
            type:Boolean,
            default:false
        },
    },
    computed: {
      isItemEmpty () {
        let flag = true
        let ar = this.form.formList || []
        for (let i = 0; i < ar.length; i++) {
          if (ar[i].lbValue !== null && ar[i].lbValue !== '' && ar[i].lbValue !== undefined) {
            flag = false
            break
          }
        }
        return flag
      }
    },
    methods:{
        isValidate (item) {
          if (this.isItemEmpty) {
            return false
          }
          return item.containType != 'N'
        },
        //关闭
        handleClose() {
            this.$emit("update:visible", false);
        },
        //查看属性标签
        getList(){
            let para = {   
                "itemappId": this.itemappId,
                "appitemid": this.item,
            };
            this.$api.newproduct.selectItemLabelsByItemappIdAndAppitemid(para).then(res => {
                if(res && res.data.code == "0" && res.data.msg == "success"){
                    let result = res.data.result;
                    this.filters.barcode = result.barcode;
                    this.filters.subclass = result.subclass;
                    this.form.formList = result.appItemmasterLabels;
                    let code = result.subclass;
                    this.form.formList.forEach((item,i)=>{
                        item.valueList = [];
                        this.getValueByCtg(code,item.lbId,'',i); //小类，标签ID，标签值
                    })
                }
            });
        },
        //查询类别关联的标签值
        getValueByCtg(code,id,val,i){
            let para= {
                ctgCode:code,  //小类
                lbId:id, //标签ID
                lbValue:val, //标签值或标签值KEY
            }
            this.$api.newproduct.selectLValueByCtg(para).then(res => {
                if(res && res.data.code == "200" && res.data.message == "success"){
                    let data = res.data.res.data;
                    this.form.formList[i].valueList = data;
                    this.form.formList= JSON.parse(JSON.stringify(this.form.formList));
                }else{
                    this.$message.error(`${res.data.message}`);
                }
            });
        },
        //修改属性标签
        submit(validName){
            this.$refs[validName].validate(valid => {
                if(valid){
                    let flag = true;
                    this.form.formList.forEach((item,i)=>{
                        if((item.containType != null && item.containType != 'N') && item.lbValue == null && !this.isItemEmpty){
                            this.$message({
                                    message: '请填写完整再保存',
                                    type: 'error'
                            });
                            flag = false;
                        }
                    })
                    if(flag == true){
                        let para = this.form.formList;
                        this.saveLoading = true;
                        this.$api.newproduct.updateAppItemmasterLabelsList(para).then(res => {
                            this.saveLoading = false;
                            if(res && res.data.code == "0" && res.data.msg == "success"){
                                this.$message({
                                        message: '保存成功！',
                                        type: 'success'
                                });
                                this.$emit("update:visible", false);
                                this.$emit('getRowsId',this.itemappId);
                            }else{
                                this.$message.error(`保存失败 ${res.data.msg}`);
                            }
                        });
                    }
                }else{
                    this.$message({
                            message: '请填写完整再保存',
                            type: 'error'
                    });
                }
            });
        },
    },
    created(){
        this.getList();
    }
}
</script>
<style lang="scss">
    .formStyle.bordernone{
        overflow: hidden;
        padding-bottom: 15px;
        border-bottom: none;
    }
    .foreachForm.formStyle{
        max-height: 200px;
        overflow-y: auto;
        border-bottom: none;
        .el-col{
            position: relative;
            .star{
                color: red;
                position: absolute;
                left: 5%;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/supermarket/dialog/attributedialog.vue